var map = {
	"./component.svg": 563,
	"./fullscreen.svg": 564,
	"./minislide.svg": 565,
	"./popup.svg": 566,
	"./slider.svg": 567
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 935;



/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/img/box/formats nonrecursive \.svg$
 ** module id = 935
 ** module chunks = 1
 **/